<div class="lot-form">
    <cb-lot-migrator-address-section
        [lotForm]="lotForm"
        [addressRegions]="addressRegions"
    ></cb-lot-migrator-address-section>

    <mat-divider></mat-divider>

    <cb-lot-migrator-lot-build-section
        [lotForm]="lotForm"
        [buildTypeOptions]="buildTypeOptions"
        [contractTypes]="contractTypes"
        [lotTypes]="lotTypes"
        [showAreas]="true"
        [showBuildTypeLink]="true"
    ></cb-lot-migrator-lot-build-section>

    <mat-divider></mat-divider>

    <cb-lot-migrator-rooms-parking-section
        [lotForm]="lotForm"
    ></cb-lot-migrator-rooms-parking-section>

    <mat-divider></mat-divider>

    <cb-lot-migrator-pricing-costs-section
        [lotForm]="lotForm"
    ></cb-lot-migrator-pricing-costs-section>
</div>
